import React from "react";
import { useState } from "react";
import EmailBox from "./EmailBox";
import { useDispatch } from "react-redux";
import { closeModal, openModal } from "../../../redux/slices/modelSlice";
import { appStyles } from "../../../utils/appStyle";
import Block from "../../../component/block";
import mixpanel from "mixpanel-browser";
import { logContentBlockPressEvent } from "../../../utils/events";

const BUTTON_WRAPPER_STYLES = {
  position: "relative",
  zIndex: 1,
};

function EmailSubscribe({ data, highlight, color, index, contentBlockId }) {
  const dispatch = useDispatch();
  const [openEmailBox, setOpenEmailBox] = useState(false);
  const handleEmailBox = () => {
    setOpenEmailBox(true);
    dispatch(openModal());
    logContentBlockPressEvent(contentBlockId);
    mixpanel.track("Web Link Clicked", {
      Button_type: "email",
    });
  };

  const handleCloseModal = () => {
    setOpenEmailBox(false);
    dispatch(closeModal());
  };

  const STYLES = appStyles(color, highlight);
  return (
    <>
      <div
        key={index}
        style={{
          marginTop: "8px",
          borderRadius: STYLES.borderRadius,
          border: STYLES.border,
          background: STYLES.background,
        }}
        onClick={handleEmailBox}
      >
        <div
          style={{
            display: "flex",
            padding: "15px",
            justifyContent: "space-between",
            alignItems: "center",
            color: STYLES.Color,
            cursor: "pointer",
          }}
        >
          <Block
            icon={data.customize?.selectedIcon}
            content={data.customize?.buttonText}
            rightIcon="fa-sharp fa-solid fa-arrow-up-right"
          />
        </div>
      </div>
      <div style={BUTTON_WRAPPER_STYLES}>
        {openEmailBox && (
          <EmailBox
            data={data?.customize}
            open={openEmailBox}
            onClose={handleCloseModal}
            type={data?.type}
            listId={data?.mail?.id}
            tags={data?.customize?.tags}
            privacyLink={data.customize.privacyLink}
          />
        )}
      </div>
    </>
  );
}

export default EmailSubscribe;
